<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="mm_title">
            <label class="weui-form-preview__label">{{
              customLabel.mm_title || "会议议题"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mm_title
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mm_date">
            <label class="weui-form-preview__label">{{
              customLabel.mm_date || "会议日期"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.mm_date, "yyyy-MM-dd") }}
              {{ form.main.mm_start }} ~ {{ form.main.mm_over }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_mrname">
            <label class="weui-form-preview__label">{{
              customLabel.mm_mrname || "会议室"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.mm_mrname }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_address">
            <label class="weui-form-preview__label">{{
              customLabel.mm_address || "地点"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_address }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_emnames">
            <label class="weui-form-preview__label">{{
              customLabel.mm_emnames || "参会人员"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_emnames }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_remind">
            <label class="weui-form-preview__label">{{
              customLabel.mm_remind || "提醒设置"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_remind }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_repeat">
            <label class="weui-form-preview__label">{{
              customLabel.mm_repeat || "重复"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_repeat }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_weekday">
            <label class="weui-form-preview__label">{{
              customLabel.mm_weekday || "是否工作日"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_weekday ? "是" : "否" }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_enddate">
            <label class="weui-form-preview__label">{{
              customLabel.mm_enddate || "截止有效日期"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.mm_enddate, "yyyy-MM-dd") }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="mm_status">
            <label class="weui-form-preview__label">{{
              customLabel.mm_status || "启用状态"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.mm_status ? "已开启" : "未开启" }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{
              customLabel.creatorName || "录入人"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.creatorName }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "录入日期"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.createTime, "yyyy-MM-dd") }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="updaterName">
            <label class="weui-form-preview__label">{{
              customLabel.updaterName || "更新人"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.updaterName }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="updateTime">
            <label class="weui-form-preview__label">{{
              customLabel.updateTime || "更新日期"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.updateTime, "yyyy-MM-dd") }}
            </span>
          </div>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/meeting_template_edit?id=' + form.main.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/meetingmodel",
      codeField: "mm_code",
      caller: "MeetingModel",
      xtype: "oa-meetingmodel-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this;
      me.$weui.confirm("确定删除单据？", function () {
        me.$loading({
          url: `/api/oa/meetingmodel/delete/${me.form.main.id}?caller=MeetingModel`,
          method: "POST",
        }).then((res) => {
          if (res.success) {
            me.$router.push("/oa/meet");
          }
        });
      });
    },
  },
};
</script>